export default __webpack_public_path__ + "img/bg1-4450a46d.png";